import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AppService, CoreTypes, FormValidatorService, IncidentTypes, LabelValue } from 'common-cloudstudio';
import { Subscription } from 'rxjs';
import { IncidentService } from '../../../services/incident.service';

@Component({
  selector: 'app-incident-damage-register',
  templateUrl: './incident-damage-register.component.html',
  styleUrls: ['./incident-damage-register.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IncidentDamageRegisterComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IncidentDamageRegisterComponent),
      multi: true,
    }
  ]
})

export class IncidentDamageRegisterComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {
  _data:  CoreTypes.ITS_IncidentDamagedMaterialAssets = new  CoreTypes.ITS_IncidentDamagedMaterialAssets();
  @Input('data')
  set data(data: string) {
    this.writeValue(data);
  }
  get data() {
    return JSON.stringify(this._data);
  }
  @Input() materialAssetsFullList: CoreTypes.ITS_MaterialAssets[] = [];
  @Output() disableForm = new EventEmitter<boolean>();
  onChange = (_:any) => { }
  onTouch = () => { }
  isDisabled: boolean;

  _damageElementList: LabelValue<number>[] = [];
  form: UntypedFormGroup = this.fb.group({
    damageElement: [[], [Validators.required]],
    quantity: [null, [Validators.required]],
    comments: ['']

  });
  subscriptions: Subscription[] = [];
  incidentElementTypes = IncidentTypes.elementTypes;

  constructor(
    private fb: UntypedFormBuilder,
    public appService: AppService,
    private incidentService: IncidentService,
    public _formValidatorService: FormValidatorService,
  ) { }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  
  public validate() {
    let errors: ValidationErrors = {};
    Object.keys(this.form.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.form.get(key).errors;
      if (controlErrors != null) {
        errors[key] = controlErrors;
      }
    });
    return errors;
  }

  ngOnInit(): void { 
    this.getDamageList();
    this.subscriptions.push(this.damageElement.valueChanges.subscribe(value => {
      if(value?.value || value?.value == 0) {
        this._data.MaterialAssetID = value?.value;
        this.onInput();
      }
    }));
    this.subscriptions.push(this.quantity.valueChanges.subscribe(value => {
      if(value){
        this._data.Quantity = value;
        this.onInput(); 
      }
    }));
    this.subscriptions.push(this.comments.valueChanges.subscribe(value => {
      if(value){
        this._data.Comments = value;
        this.onInput(); 
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnChanges() {
    this.getDamageList();
  }

  onInput() {
    !this.damageElement?.value?.value ? this.disableForm.emit(true) : this.disableForm.emit(false);
    this.onTouch();
    this.onChange(JSON.stringify(this._data));
  }

  writeValue(value: any): void {
    if (value) {
      this._data = JSON.parse(value);
    } else {
      this._data = new CoreTypes.ITS_IncidentDamagedMaterialAssets();
    }

    const damage = this._data?.MaterialAssetID
    ? this._damageElementList.find(s => s.value === this._data?.MaterialAssetID)
    : this._damageElementList[0];
    this.damageElement.setValue(damage);
    this.quantity.setValue(this._data?.Quantity);
    this.comments.setValue(this._data?.Comments);
    
    this.onInput();
  }
  
  async getDamageList() {
    if (!this.materialAssetsFullList?.length) { return; }
    const optionsList: LabelValue<number>[] = [];
    this.materialAssetsFullList.forEach(x => {
      const item: LabelValue<number> = {
        label: x?.MaterialAssetDescription ? x?.MaterialAssetDescription : x?.MultiLangDescription?.ES_AR,
        value: x?.MaterialAssetID,
        disabled: this.disabledItem(x?.MaterialAssetID)
      };
      optionsList.push(item);
    });
    this._damageElementList = optionsList;
    this.onInput();
  }

  disabledItem(element: any): boolean {
    return this.incidentService.isItemSelectedInSection(this.incidentElementTypes.DamageRegister, element);
  }

  updateValuesAndValidations(form) {
    setTimeout(() => {
      const errors: ValidationErrors = [];
      for (const prop in form.controls) {
        form.controls[prop].updateValueAndValidity();
        if (form.controls[prop].errors) {
          const controlErrors: ValidationErrors = form.controls[prop].errors;
          if (controlErrors) { errors.push(controlErrors); }
        }
      }
    }, 20);
  }
  
  limitDecimalPlaces(event) {
    let value = event.target.value;
    if (value === "") {
      event.target.value = "";
      return;
    }
    if (value.includes('.')) {
      const [integerPart, decimalPart] = value.split('.');
      if (decimalPart?.length > 2) {
        event.target.value = `${integerPart}.${decimalPart.substring(0, 2)}`;
        this.quantity.setValue(event.target.value )
      }
    }
  }

  get damageElement() { return this.form.get('damageElement'); }
  get quantity() { return this.form.get('quantity'); }
  get comments() { return this.form.get('comments'); }


}
